<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">获取发票</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">获取发票</div>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-master z-margin-bottom-5-precent">
          <p>1：开票金额如果低于500元，邮寄发票需要支付10元邮寄费用(！注：偏远地区需支付20元)，并联系在线客服。500元以上免费邮寄。</p>
          <p>2：如开取发票金额低于500元，请在提交后联系在线客服人员支付邮寄费用。</p>
        </div>
        <div class="detail-title">
          可开发票列表
        </div>
        <div class="detail-body z-lineHeight-16">
          <!--<span class="z-font-size-13 z-font-weight-700" style="color:#ff0000;">发票信息：</span>
          <br>
          <br>
          <div class="z-padding-left-20-precent z-font-size-13">
            <span class="z-font-size-13 z-font-weight-700" style="color:#ff0000;">发票抬头：</span>{{kd_taitou}}
            &nbsp;&nbsp;&nbsp;
            <span class="z-font-size-13 z-font-weight-700" v-if="kd_nsrsbh" style="color:#ff0000;">纳税人识别号：</span>{{kd_nsrsbh}}
            &nbsp;&nbsp;&nbsp;
            <span class="z-font-size-13 z-font-weight-700" v-if="kd_nsrsbh" style="color:#ff0000;">发票类型：</span><span v-if="kd_fplx === '1'" class="z-font-size-13">增值税普通发票</span><span v-if="kd_fplx === '2'" class="z-font-size-13">增值税专用发票</span>
            <br>
            <br>
            <span class="z-font-size-13 z-font-weight-700" style="color:#ff0000;">发票快递信息：</span>
            <span class="z-font-size-13">地址：{{kd_address}}</span>&nbsp;&nbsp;
            <span class="z-font-size-13">手机号：{{kd_tel}}</span>&nbsp;&nbsp; <span class="z-font-size-13">联系人姓名：{{kd_linkman}}</span>
            <br>
            <br>
          </div>-->
          <el-radio-group v-model="ctaitou" size="small">
            <el-radio-button v-for="item in invoiceList" :key="item.taitou" :label="item.taitou"></el-radio-button>
          </el-radio-group>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addInvoice">新增发票信息</el-button>
          <div class="z-margin-top-10-precent">
            <span class="z-font-size-13">已选总金额：￥{{caiwu}}</span>
            <span class="z-font-size-13">（可开票总金额：￥{{kekai_caiwu}}）</span>
            <div class="z-display-inlineBlock">
              <el-button type="primary" size="mini" :disabled="(multipleSelection.length === 0 || invoiceList.length === 0) ? true : false" @click="confirmInvoice = (multipleSelection.length > 0 && invoiceList.length > 0 ) ? true : false">开取发票</el-button>
            </div>
          </div>
        </div>
        <!--列表-->
        <el-table :data="userList" border highlight-current-row show-header v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
          <el-table-column type="selection" :selectable="selectable" width="40">
          </el-table-column>
          <el-table-column prop="id" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="caiwu_type" label="财务类型" align="center">
          </el-table-column>
          <el-table-column prop="income_type" label="充值方式" align="center">
          </el-table-column>
          <el-table-column prop="caiwu_money" label="金额" align="center">
          </el-table-column>
          <el-table-column prop="caiwu_time" label="充值时间" align="center">
          </el-table-column>
          <el-table-column prop="invoice" label="是否开具发票" align="center">
          </el-table-column>
        </el-table>

        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>

      </div>
    </div>
    <!--设置发票信息-->
    <el-dialog
      title="设置发票信息"
      :visible.sync="dialogInvoice"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="30%">
      <p class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">开具类型：</span>
        <label for="f_t_gr" class="z-font-size-13"><input type="radio" name="f_taitou" id="f_t_gr" v-model="setInvoice.type" value="person">&nbsp;个人</label>
        &nbsp;&nbsp;
        <label for="f_t_qy" class="z-font-size-13"><input type="radio" name="f_taitou" id="f_t_qy" v-model="setInvoice.type" value="company">&nbsp;企业</label>
      </p>
      <p v-if="setInvoice.type === 'company'" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">发票类型：</span>
        <label for="person" class="z-font-size-13"><input type="radio" name="fp_type" id="person" v-model="fplx" value="1">&nbsp;增值税普通发票</label>
        &nbsp;&nbsp;
        <label for="company" class="z-font-size-13"><input type="radio" name="fp_type" id="company" v-model="fplx" value="2">&nbsp;增值税专用发票</label>
      </p>
      <p v-if="setInvoice.type === 'person'" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">发票抬头：</span>
        <span>个人</span>
      </p>
      <p v-if="setInvoice.type === 'company'" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">发票抬头：</span>
        <input type="text" v-model="taitou" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p v-if="setInvoice.type === 'company'" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">纳税人识别号：</span>
        <input type="text" v-model="nsrsbh" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">收件人姓名：</span>
        <input type="text" v-model="linkman" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">收件人电话：</span>
        <input type="text" v-model="tel" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">收件人地址：</span>
        <input type="text" v-model="address" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p v-show="setInvoice.type === 'company' && fplx == 2" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">开户行：</span>
        <input type="text" v-model="khhmc" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p v-show="setInvoice.type === 'company' && fplx == 2" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">账号：</span>
        <input type="text" v-model="khhzh" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p v-show="setInvoice.type === 'company' && fplx == 2" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">注册地址：</span>
        <input type="text" v-model="zcdz" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <p v-show="setInvoice.type === 'company' && fplx == 2" class="z-lineHeight-40">
        <span class="z-display-inlineBlock z-width-16-precent z-textAlign-right z-font-weight-700">注册电话：</span>
        <input type="text" v-model="zcdh" class="z-font-size-13 z-color-666 z-width-50-precent">
      </p>
      <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="dialogInvoice = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="saveInfo"></xbutton></span>
            </span>
    </el-dialog>
    <!--确认发票信息-->
    <el-dialog
      title="确认发票信息"
      :visible.sync="confirmInvoice"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="30%">
      <p class="z-lineHeight-30">
        <span>发票抬头：</span>
        <span>{{chooseList.taitou}}</span>
      </p>
      <p class="z-lineHeight-30">
        <span>发票类型：</span>
        <span>{{ftype}}</span>
      </p>
      <p class="z-lineHeight-30">
        <span>发票内容：</span>
        <select v-model="invoice_type" class="z-color-666">
          <option value="请选择发票内容">请选择发票内容</option>
          <option value="网站服务费">网站服务费</option>
          <option value="空间费">云服务器租用费</option>
          <option value="vps服务费">域名费</option>
          <option value="域名费">虚拟主机租用费</option>
          <option value="空间域名费">网络服务费</option>
        </select>
      </p>
      <div class="z-lineHeight-30">
        <span>快递信息：</span>
        <div class="z-padding-left-20-precent">
          <p class="z-lineHeight-30"><span>收件人：</span><span>{{chooseList.linkman}}</span></p>
          <p class="z-lineHeight-30"><span>收件人联系方式：</span><span>{{chooseList.tel}}</span></p>
          <p class="z-lineHeight-30"><span>收件人地址：</span><span>{{chooseList.address}}</span></p>
        </div>
      </div>
      <p class="z-lineHeight-30">
        <span>开票金额：</span>
        <span class="z-color-red">￥{{caiwu}}</span>
      </p>
      <p class="z-lineHeight-30">
        <span class="z-color-red">提示信息：</span>
        <span class="z-color-red">开票金额小于500元，需要支付10元快递费用</span>
      </p>
      <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="取 消" type="cancel" @XbuttonService="confirmInvoice = false"></xbutton></span>
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="submitInvoice" :class="{'is-disabled':invoice_type === '请选择发票内容'}"></xbutton></span>
            </span>
    </el-dialog>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import Xtable from 'components/commons/Xtable.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import caiwuService from 'business/caiwuService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  export default {
    data() {
      return {
        dialogLoading:false,
        UserName:'',
        kd_address:'',
        kd_linkman:'',
        kd_taitou:'',
        kd_tel:'',
        kd_nsrsbh:'',
        kd_fplx:'',
        kd_khhmc:'',
        kd_khhzh:'',
        kd_zcdz:'',
        kd_zcdh:'',
        setInvoice:{
          type:''
        },
        ctaitou:'',
        ftype:'',
        invoiceList:[],
        chooseList:{},
        address:'',
        linkman:'',
        taitou:'',
        tel:'',
        nsrsbh:'',
        fplx:'',
        khhmc:'',
        khhzh:'',
        zcdz:'',
        zcdh:'',
        userList: [],
        listLoading:false,
        currentPage: 0,
        count: 10,
        total: 0,
        page:1,
        date: [],
        dialogInvoice: false,
        confirmInvoice: false,
        multipleSelection: [],
        idSelection: [],
        caiwu:'0.00',
        kekai_caiwu:0,
        invoice_type:'请选择发票内容'
      }
    },
    components:{
      Xtable,
      Xbutton,
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.InvoiceMod()
      /*this.getUserinfo()*/
      this.SearchInvoice()
    },
    computed: {
      kilx() {
        return this.setInvoice.type
      },
    },
    watch:{
      kilx(val,oldval){
        if(oldval != ''){
          if(val === 'company'){
            this.fplx = '1'
          }
        }
      },
      ctaitou(val) {
        if(val != ''){
          this.chooseList = this.invoiceList.filter(items => {
            return items.taitou === val
          })[0]
          this.ftype = this.chooseList.fplx === '2' ? '增值税专用发票' : '增值税普通发票'
        }
      }
    },
    methods:{
      async InvoiceMod() {
        this.listLoading = true
        let data = 'cmd=invoice_mod_list'
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          /*this.total = vueData.allcount*/
          this.invoiceList = vueData.msg
          this.ctaitou = this.invoiceList.length> 0 ? vueData.msg[0].taitou : ''
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      addInvoice() {
        this.$router.push('/invoiceadd')
      },
      async getUserinfo() {
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST','cmd=query_kd')
        if(vueData.response == 200 ) {
          this.UserName = vueData.msg.UserName
          this.kd_address = vueData.msg.address
          this.kd_linkman = vueData.msg.linkman
          this.kd_taitou = vueData.msg.taitou
          this.kd_tel = vueData.msg.tel
          this.kd_nsrsbh = vueData.msg.nsrsbh
          this.kd_fplx = vueData.msg.fplx
          this.kd_khhmc = vueData.msg.khhmc
          this.kd_khhzh = vueData.msg.khhzh
          this.kd_zcdz = vueData.msg.zcdz
          this.kd_zcdh = vueData.msg.zcdh

          this.address = vueData.msg.address
          this.linkman = vueData.msg.linkman
          this.taitou = vueData.msg.taitou
          this.tel = vueData.msg.tel
          this.nsrsbh = vueData.msg.nsrsbh
          this.fplx = vueData.msg.fplx
          this.khhmc = vueData.msg.khhmc
          this.khhzh = vueData.msg.khhzh
          this.zcdz = vueData.msg.zcdz
          this.zcdh = vueData.msg.zcdh
          this.setInvoice.type = vueData.msg.fplx === '0' ? 'person' : 'company'
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SearchInvoice() {
        this.listLoading = true
        let data = 'cmd=invoice_caiwu_list'+'&count='+ this.count +'&page='+ this.page
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.kekai_caiwu = vueData.sum - vueData.yikai

          this.total = vueData.data.allcount
          this.userList = vueData.data.content.map((item, index) => {
            return {
              id:item.id,
              caiwu_type:item.caiwu_type == 1 ? '充值' : '消费',
              income_type:item.income_type,
              caiwu_money:item.caiwu_money,
              caiwu_time:item.caiwu_time,
              invoice:item.invoice ? '已开' : '未开'
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async saveInfo() {
        let data
        if(this.setInvoice.type === 'person'){
          data = 'cmd=up_invoice_kd'+'&tel='+ this.tel+'&address='+ this.address+'&linkman='+ this.linkman+'&taitou=个人&fplx=0'+'&nsrsbh='+ this.nsrsbh+'&khhmc='+ this.khhmc+'&khhzh='+ this.khhzh+'&zcdz='+ this.zcdz+'&zcdh='+ this.zcdh
        }else{
          if(this.fplx === '1'){
            data = 'cmd=up_invoice_kd'+'&tel='+ this.tel+'&address='+ this.address+'&linkman='+ this.linkman+'&taitou='+ this.taitou+'&nsrsbh='+ this.nsrsbh+'&fplx='+ this.fplx+'&khhmc='+ this.khhmc+'&khhzh='+ this.khhzh+'&zcdz='+ this.zcdz+'&zcdh='+ this.zcdh
          }else {
            data = 'cmd=up_invoice_kd'+'&tel='+ this.tel+'&address='+ this.address+'&linkman='+ this.linkman+'&taitou='+ this.taitou+'&nsrsbh='+ this.nsrsbh+'&fplx='+ this.fplx+'&khhmc='+ this.khhmc+'&khhzh='+ this.khhzh+'&zcdz='+ this.zcdz+'&zcdh='+ this.zcdh
          }
        }
        this.dialogLoading = true
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.dialogInvoice = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.getUserinfo()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async submitInvoice () {
        if(this.invoice_type != '请选择发票内容'){
          let data = 'cmd=add_invoice' + '&invoice_mod_id='+ this.chooseList.id + '&id='+ this.idSelection + '&invoice_content='+ this.invoice_type
          let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
          if(vueData.response == 200 ) {
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {
                self.confirmInvoice = false
                self.$router.push('/invoicelist')
              }})
          }else {
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchInvoice()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchInvoice()
      },
      selectable(row,index) {
        if(row.invoice==="已开"){
          return false
        }else {
          return true
        }
      },
      selsChange: function (sels) {
        this.caiwu = 0
        this.multipleSelection = sels;
        this.idSelection = this.multipleSelection.map(item => item.id);
        this.multipleSelection = this.multipleSelection.map(item => item.caiwu_money);
        for (var i = 0; i < this.multipleSelection.length; i++){
          this.caiwu = 0
          this.multipleSelection.map(this.getSum);
        }
      },
      getSum (item, index, array){
        this.caiwu += Number(item);
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .is-disabled { cursor: not-allowed; opacity: .65; filter: alpha(opacity=65);}
  .panel-body {
    font-size: 13px;
  }
  .detail-title {
    font-weight: bold;
    margin-top: 30px;
    background: #f8f8f8;
    font-size: 18px;
    line-height: 2em;
    padding: 7px 22px 5px 15px;
    border: 1px solid #ddd;
  }
  .detail-body {
    padding: 20px;
    border: 1px solid #ddd;
    border-top-width: 0;
    border-bottom-width: 0;
  }
  select {
    width: 220px;
    border: 1px solid #ccc;
    background-color: #fff;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
  }
  select option {
    font-size: 13px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/caiwu/caiwu3.vue